var Forms = {};
Forms.clearFormErrors = function (form) {
  $(form).find('[data-for]').hide();
};
Forms.validateFields = function (form, fields, errors) {
  var errors = errors || {
    length: 0
  };
  fields.forEach(function (field) {
    var input = form.elements[field.name];
    var name = field.name;
    if (field.required === true) {
      var isEmpty = false;
      if ($(input).is(':radio') || $(input).is(':checkbox')) {
        var type = $(input).attr("name");
        var checked = $(form).find('[name="' + type + '"]').filter(function () {
          return this.checked;
        });
        if (checked.length === 0) {
          isEmpty = true;
        }
      } else if (!input.value) {
        isEmpty = true;
      }
      if (isEmpty) {
        errors.length++;
        errors[name] = errors[name] || {};
        errors[name].required = true;
        $(form).find('[data-for="' + name + '"][data-kind="required"]').show();
      }
    }
    if (typeof field.required === "function") {
      if (!field.required(input, form)) {
        errors.length++;
        errors[name] = errors[name] || {};
        errors[name].required = true;
        $(form).find('[data-for="' + name + '"][data-kind="required"]').show();
      }
    }
    if (typeof field.regexp === "function") {
      if (!field.regexp(input, form)) {
        errors.length++;
        errors[name] = errors[name] || {};
        errors[name].required = true;
        $(form).find('[data-for="' + name + '"][data-kind="regexp"]').show();
      }
    }
  });
  return errors;
};